var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 2.16943C11.7736 1.89572 12.2264 1.89572 12.5156 2.16943C14.5324 4.0794 17.2538 5.24951 20.25 5.24951C20.2976 5.24951 20.3451 5.2501 20.3926 5.24951C20.7199 5.24545 21.012 5.45413 21.1143 5.76514C21.5268 7.01984 21.75 8.36005 21.75 9.75049C21.7498 15.6923 17.6854 20.6828 12.1865 22.0981C12.0641 22.1296 11.9359 22.1296 11.8135 22.0981C6.31462 20.6828 2.25021 15.6923 2.25 9.75049C2.25 8.36005 2.47324 7.01984 2.88574 5.76514C2.988 5.45413 3.28006 5.24545 3.60742 5.24951C3.65487 5.2501 3.7024 5.24951 3.75 5.24951C6.74624 5.24951 9.46762 4.0794 11.4844 2.16943ZM15.4355 9.13916C15.0985 8.8988 14.6303 8.97706 14.3896 9.31396L11.1543 13.8433L9.53027 12.2192C9.23743 11.9266 8.76257 11.9266 8.46973 12.2192C8.1769 12.5121 8.17702 12.9869 8.46973 13.2798L10.7197 15.5298C10.8755 15.6856 11.0919 15.7656 11.3115 15.7476C11.5312 15.7294 11.7322 15.6154 11.8604 15.436L15.6104 10.186C15.8511 9.84898 15.7726 9.37992 15.4355 9.13916Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.7aa1d0f2a4eb280c611729b842d3f1f7.svg";
export { ForwardRef as ReactComponent };